import _ from 'underscore';
import { getLogger } from '../logging/logger';

const logger = getLogger('CookieStorageManager');

class PersistentStorageManager {
	get cookieIds() {
		return ['_ga', 'access-token-v2', 'hwptv-access-token'];
	}

	get domain() {
		return '.hollywoodplayer.com';
	}

	get path() {
		return '/';
	}

	storeCookiesToLocalStorage() {
		logger.log('[storeCookiesToLocalStorage]');
		_.each(this.cookieIds, this.storeCookieToLocalStorage.bind(this));
	}

	storeCookieToLocalStorage(cookieId) {
		logger.log('[storeCookieToLocalStorage]', cookieId);
		// Alerts.info('[storeCookieToLocalStorage] '+cookieId);
		const cookies = this.getCookies();
		if (_.has(cookies, cookieId)) {
			this.setLocalStorageValue(cookieId, cookies[cookieId]);
		}
	}

	retrieveCookieFromLocalStorage(cookieId) {
		logger.log('[retrieveCookieFromLocalStorage]', cookieId);
		this.setCookie(cookieId, this.getLocalStorageValue(cookieId));
	}

	getCookies() {
		logger.log('[getCookies]');
		const cookieStrings = document.cookie.split(';');
		const cookies = {};
		cookieStrings.forEach((cookieStr) => {
			const cookieHalves = cookieStr.split('=');
			if (_.every(cookieHalves, _.string)) {
				cookies[cookieHalves[0].trim()] = cookieHalves[1].trim();
			}
		});

		return cookies;
	}

	getCookie(key) {
		logger.log('[getCookie]', key);
		return _.result(this.getCookies(), key, '');
	}

	setCookie(key, value) {
		logger.log('[setCookie]', key, value);
		if (!_.isEmpty(key) && typeof value === 'string') {
			const expirationDate = new Date('Tue, 31 Dec 2999 23:59:59 GMT');
			document.cookie = `${key}=${value};domain=${this.domain};path=${
				this.path
			};expires=${expirationDate.toUTCString()}`;
		} else {
			logger.warn(`[unable to set cookie][${key}: ${value}]`);
		}
	}

	getLocalStorageValue(key) {
		logger.log('[getLocalStorageValue]', key);
		let val = '';
		if (localStorage) {
			val = localStorage.getItem(key);
			logger.log('[getLocalStorageValue] retrieved:', val);
		} else {
			logger.warn('Unable to find LocalStorage');
		}
		return val;
	}

	setLocalStorageValue(key, value) {
		logger.log('[setLocalStorageValue]', key, value);

		if (localStorage && key && value) {
			localStorage.setItem(key, value);
			logger.log('[setLocalStorageValue] set', key, 'as', value);
		} else {
			logger.warn(`[unable to set local storage value][${key}: ${value}]`);
		}
	}

	removeLocalStorageValue(key) {
		logger.log('[removeLocalStorageValue]', key);

		if (localStorage && key) {
			localStorage.removeItem(key);
			logger.log('[removeLocalStorageValue] removed', key);
		} else {
			logger.warn(`[unable to remove local storage value] ${key}`);
		}
	}
}

export default new PersistentStorageManager();
